define('shared/util/dispatchers/retrieverFactory',[
    './retrievers/cookie', 
    './retrievers/omniture', 
    './retrievers/query', 
    './retrievers/state', 
    './retrievers/queryPersistence',
    './retrievers/clientId',
    './retrievers/cmus',
    './retrievers/form'
],
function (cookie, omniture, query, state, queryPersistence, clientId, cmus, form) {
    'use strict';

    var RETRIEVERS = {
        'cookie': cookie,
        'omniture': omniture,
        'query': query,
        'state': state,
        'queryPersistence': queryPersistence,
        'clientId': clientId,
        'cmus': cmus,
        'form': form
    };

    return {
        create: function ( source ) {

            if ( typeof source.retrieve == 'function' ) {
                return source.retrieve;
            }
            else {
                return RETRIEVERS[ source.type ];
            }
            
        }
    };
});
